type FileServerData = Record<string, unknown> | null | undefined;

interface FileServerPageNotFoundParams {
  fileServerData: FileServerData;
  pageRoute: string;
  pathname?: string;
  queryUrl?: string | string[];
}

export function getSingleQueryValue(
  value: string | string[] | undefined
): string | null {
  if (Array.isArray(value)) {
    return value[0] || null;
  }

  return typeof value === "string" && value.length > 0 ? value : null;
}

export function getFileServerPagePath(pageUrl: string): string {
  return `data/${pageUrl}.html`;
}

export function hasFileServerPage(
  fileServerData: FileServerData,
  pageUrl: string | null | undefined
): pageUrl is string {
  return Boolean(pageUrl && fileServerData?.[getFileServerPagePath(pageUrl)]);
}

export function shouldRenderFileServerPageNotFound({
  fileServerData,
  pageRoute,
  pathname,
  queryUrl,
}: FileServerPageNotFoundParams): boolean {
  if (pathname !== pageRoute) {
    return false;
  }

  return !hasFileServerPage(fileServerData, getSingleQueryValue(queryUrl));
}
